import { rolePermissions } from "../data/roleAccess";
import { logout } from "./auth";
import { decodeToken } from "./auth";

export const roles = [
  { key: "AdminUser", label: "Super Admin" },
  { key: "SubAdmin", label: "Admin" },
  { key: "Cashier", label: "Cashier" },
  { key: "Operation", label: "Operations Staff" },
  { key: "Developer", label: "Technical Support" }
];

export const formatText = (text) =>
  text.replace(/([A-Z])/g, " $1").replace(/^./, (s) => s.toUpperCase());

const normalizeRoles = (roleInput) => {
  if (!roleInput) return [];

  if (Array.isArray(roleInput)) {
    return roleInput.map((r) => String(r).trim()).filter(Boolean);
  }

  if (typeof roleInput === "string") {
    return roleInput
      .split(",")
      .map((r) => r.trim())
      .filter(Boolean);
  }

  return [String(roleInput).trim()];
};

export const getPermissionsForRole = (roleString) => {
  const roleList = normalizeRoles(roleString);

  const isValidRole = roleList.some((role) =>
    roles.some((r) => r.key === role)
  );

  if (!isValidRole) {
    logout("/login");
  }
  if (roleList.includes("AdminUser")) {
    return "ALL";
  }

  const result = {};

  Object.entries(rolePermissions).forEach(([module, actions]) => {
    Object.entries(actions).forEach(([action, allowedRoles]) => {
      const hasAccess = roleList.some((role) => allowedRoles.includes(role));

      if (hasAccess) {
        if (!result[module]) result[module] = [];
        result[module].push(action);
      }
    });
  });

  return result;
};

export const can = (permissions, module, action) => {
  if (permissions === "ALL") return true;
  return permissions?.[module]?.includes(action);
};

export const getCurrentUserRole = () => {
  const decoded = decodeToken("da");
  return decoded?.roles || null;
};
